<template>
  <div>
    <div class="accordion-group">
      <h2 class="accordion-header select-dealer-header" data-state="open" tabindex="0" @click="showMap = !showMap" :class="{'accordion-header-complete': $store.state.form.dealer}"><span v-if="$store.state.form.dealer">{{$store.state.form.dealer.name}}</span><span v-else v-html="$store.state.texts.dealer.title"></span></h2>
      <div v-if="$store.state.form.car.model && (!$store.state.form.dealer || showMap)" class="accordion-panel select-dealer-content" data-state="open" style="display: block; height: auto;">
        <div class="c_040 batd fad-simple-detail is-initialized" v-bind:class="{'is-selected': selectedDealer}" data-auto-zoom-limit="" data-preferred-zoom="" data-current-zoom-level="1" data-show-api-results-only="false">
          <div class="c_040-form">
            <div class="grid-row bleed">
              <div class="col-12">
                <fieldset>
                  <div class="c_152-0">
                    <span class="location-fields">
                      <GmapAutocomplete
                        class="location-input"
                        :placeholder="$store.state.texts.dealer.location"
                        name="location"
                        data-no-results-text="Iskanje ni vrnilo rezultata - prosimo kontaktirajte Nissan svetovalca za pomoč"
                        @place_changed="setPlace">
                      </GmapAutocomplete>
                      <button type="button" class="btn-search">Iskanje</button>
                      <button  @click="getCurrentLocation" type="button" class="btn-geolocate" data-text="Trenutna lokacija">
                          Trenutna lokacija
                      </button>
                      <span class="autocomplete-suggestions"></span>
                    </span>
                    <input name="latlong" class="location-value" disabled="" value="" type="hidden">
                  </div>
                </fieldset>
              </div>
            </div>
            <div class="location-results">
              <div class="grid-row bleed">
                <div class="col-12">
                  <div class="results-text"></div>
                </div>
              </div>
                <div class="view-map is-active" tabindex="-1">
                  <!-- START C_022 -->
                  <div class="map-wrapper" v-bind:class="{'is-showing-detail': selectedDealer}">
                    <div class="map-cell">
                      <GmapMap
                        :center="startcenter"
                        :zoom="zoom"
                        style="position: relative; overflow: hidden;"
                        class="c_022"
                      >
                        <GmapCluster
                         :styles="clusterStyles"
                         :zoom-on-click="true"
                        >
                          <GmapMarker
                            :key="index"
                            v-for="(m, index) in getMarks()"
                            :position="m.pos"
                            :clickable="true"
                            icon="/static/brand-marker.png"
                            @click="clickedDealer(m)"
                          />
                          <GmapMarker
                            v-if="selfMarker"
                            :position="selfMarker.position"
                            :clickable="false"
                            icon="/static/geo.png"
                          />
                        </GmapCluster>
                      </GmapMap>
                    </div>
                    <div class="map-results">
                      <div class="c_056-single-dealer c_040-2" :class="{'is-showing-more': showDealerdetails}" id="map-si_nissan_70500032" v-if="selectedDealer">
                          <div class="heading-group">
                              <h2>
                                  <span class="position marker-"><img src="/static/brand-marker-black.png"></span>
                                  <span v-html="selectedDealer.name"></span>
                              </h2>
                              <p v-html="selectedDealer.address.zip">
                              </p>
                          </div>
                          <div class="more-dealer-info">
                              <div class="dealer-address">
                                  <h3 v-html="$store.state.texts.dealer.address"></h3>
                                  <p v-html="selectedDealer.address.line1"></p>
                                  <p v-html="selectedDealer.address.line2"></p>
                                  <p v-html="selectedDealer.address.line3"></p>
                                  <p v-html="selectedDealer.address.city"></p>
                                  <p v-html="selectedDealer.address.zip"></p>
                              </div>
                              <div class="dealer-hours">
                                  <h3 v-html="$store.state.texts.dealer.workTime"></h3>
                                  <table>
                                      <tbody>
                                          <tr class="opening-day">
                                              <td class="weekday" v-html="$store.state.texts.dealer.workDays.monday"></td>
                                              <td>
                                                  <span v-html="selectedDealer.work.mon"></span>
                                              </td>
                                          </tr>
                                          <tr class="opening-day">
                                              <td class="weekday" v-html="$store.state.texts.dealer.workDays.tuesday"></td>
                                              <td>
                                                  <span v-html="selectedDealer.work.tue"></span>
                                              </td>
                                          </tr>
                                          <tr class="opening-day">
                                              <td class="weekday" v-html="$store.state.texts.dealer.workDays.wednesday"></td>
                                              <td>
                                                  <span v-html="selectedDealer.work.wed"></span>
                                              </td>
                                          </tr>
                                          <tr class="opening-day">
                                              <td class="weekday" v-html="$store.state.texts.dealer.workDays.thursday"></td>
                                              <td>
                                                  <span v-html="selectedDealer.work.thu"></span>
                                              </td>
                                          </tr>
                                          <tr class="opening-day">
                                              <td class="weekday" v-html="$store.state.texts.dealer.workDays.friday"></td>
                                              <td>
                                                  <span v-html="selectedDealer.work.fri"></span>
                                              </td>
                                          </tr>
                                          <tr class="opening-day">
                                              <td class="weekday" v-html="$store.state.texts.dealer.workDays.saturday"></td>
                                              <td>
                                                  <span v-html="selectedDealer.work.sat"></span>
                                              </td>
                                          </tr>
                                          <tr class="opening-day">
                                              <td class="weekday" v-html="$store.state.texts.dealer.workDays.sunday"></td>
                                              <td v-html="selectedDealer.work.sun"><span></span></td>
                                          </tr>
                                      </tbody>
                                  </table>
                              </div>
                          </div>
                          <div class="item-actions">
                              <a @click="showDealerdetails = !showDealerdetails" class="btn-show-more" data-alt="Prikaži manj">
                                  <span>Pokaži više</span>
                              </a>
                              <button type="button" class="btn-fad btn-select" data-id="si_nissan_70500032" @click="setDealer()" v-html="$store.state.texts.dealer.pickBtn">
                              </button>
                          </div>
                      </div>
                      <div class="view-list-actions">
                          <span class="page-count">Dealer page null of 12</span>
                          <a href="#" class="btn-batd-prev js-btn-prev" data-id="si_nissan_70500032">
                              Prejšnji pooblaščeni prodajalec
                          </a>
                          <a href="#" class="btn-batd-next js-btn-next" data-id="si_nissan_70500032">
                              Naslednji pooblaščeni prodajalec
                          </a>
                      </div>
                  </div>

                  <div class="item-actions-last">
                    <button type="button" class="btn-fad btn-select" style="display: inline-block;" @click="setDealer()" v-html="$store.state.texts.dealer.pickBtn"></button>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'MapDealer',
  data () {
    return {
      showDealerdetails: false,
      startcenter: {lat: 44.713737, lng: 20.789994},
      googleMapsInitialized: false,
      clusterStyles: [
        {
          anchorIcon: [40, 15],
          height: 40,
          url: '/static/marker.png',
          width: 35,
          textColor: '#FFFFFF',
          textSize: 14
        }
      ],
      zoom: 6,
      selectedDealer: null,
      selfMarker: null,
      showMap: false
    }
  },
  computed: {
    icon () {
      let baseIcon = {
        path: '/static/brand-marker.png'
      }
      if (this.googleMapsInitialized) {
        // we have google maps in the window
        baseIcon.scaledSize = new window.google.maps.Size(30, 30)
      }
      console.log(baseIcon)
      return baseIcon
    }
  },
  methods: {
    getMarks () {
      if (this.$store.state.form.car.model.electric) {
        return this.$store.state.dropdowns.dealers.filter((val) => {
          console.log(val.electric)
          return val.electric === true
        })
      }
      return this.$store.state.dropdowns.dealers
    },
    clickedDealer (dealer) {
      console.log(dealer.position)
      this.startcenter = dealer.position
      this.selectedDealer = dealer
    },
    setDealer () {
      this.showMap = false
      this.$store.state.form.dealer = this.selectedDealer
      setTimeout(function () {
        $('html, body').animate({
          scrollTop: $('#user-details').offset().top
        }, 1000)
      }, 100)
    },
    setPlace (place) {
      this.startcenter = place.geometry.location
      this.zoom = 10
    },
    usePlace () {
      console.log('usePlace')
    },
    getCurrentLocation () {
      navigator.geolocation.getCurrentPosition((position) => {
        // let pos = {
        //     lat: position.coords.latitude,
        //     lng: position.coords.longitude
        // };
        // this.center.lat = pos.lat;
        // this.center.lng = pos.lng;
        // this.markers[0].position.lat = pos.lat;
        // this.markers[0].position.lng = pos.lng;

        // this.geocodeLatLng(new google.maps.Geocoder, pos, google.maps.InfoWindow);
        var pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
        this.startcenter = pos
        this.zoom = 10
        this.selfMarker = {
          position: pos
        }
      })
    }
  }
}
</script>

<style scoped>
.c_056-single-dealer.c_040-2 .heading-group .position {
    background: url('/static/brand-marker-black.png') center/100% no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/form/MapDealer.vue